import { ERROR_CODE_PATTERN } from '../constants/analytics-property.constants';

export const resolveBackendErrorCode = (...candidates: Array<unknown>): string | undefined =>
  candidates.find((candidate): candidate is string => typeof candidate === 'string' && ERROR_CODE_PATTERN.test(candidate));
